import React from 'react';
import { Link } from 'react-router-dom';
import './AIDisclaimer.css';

/**
 * AB 3030 / AI disclosure notice.
 * Place on any page that displays AI-generated content.
 *
 * @param {string} variant - "inline" | "footer" (default: "inline")
 */
function AIDisclaimer({ variant = 'inline' }) {
  return (
    <div className={`ai-disclaimer ai-disclaimer--${variant}`}>
      <span>
        AI-generated content, for educational use only, not medical advice.
        Debono is not a drug dosage calculator; any dosing information in
        quizzes is for exam preparation only.{' '}
        <Link to="/terms">Learn more</Link>
      </span>
    </div>
  );
}

export default AIDisclaimer;
